import React from "react";
import type { UserIdentification } from "target_wasm";
import { Tooltip } from "components/common/Tooltip";

/** A model someone has open now: the green dot people read as "online", on its
 *  icon's corner and glowing. One per person, however many tabs. */
export const LiveBadge: React.FC<{ sessions: UserIdentification[] }> = ({
  sessions,
}) => {
  const count = new Set(sessions.map((s) => s.user_id_js())).size;
  if (count === 0) return null;
  const label = `${count} active ${count === 1 ? "user" : "users"}`;
  return (
    <span className="absolute -bottom-0.5 -right-0.5 flex">
      <Tooltip title={label}>
        <span className="live-badge" role="img" aria-label={label} />
      </Tooltip>
    </span>
  );
};
